/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VideoDto } from '../../models/video-dto';

export interface VideoControllerDelete$Params {
  id: string;
}

export function videoControllerDelete(http: HttpClient, rootUrl: string, params: VideoControllerDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<VideoDto>> {
  const rb = new RequestBuilder(rootUrl, videoControllerDelete.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VideoDto>;
    })
  );
}

videoControllerDelete.PATH = '/api/videos/{id}';
